module.exports = __webpack_public_path__ + "static/media/ouman.fb92c587.png";